export const GAME_CONFIG = {
    // Game Settings
    GAME_WIDTH: 1920,
    GAME_HEIGHT: 1080,
    TARGET_FPS: 60,
    
    // Physics Settings
    PHYSICS_TIMESTEP: 1 / 60,
    GRAVITY: -9.81,
    
    // Player Settings
    PLAYER_SPEED: 5,
    PLAYER_JUMP_FORCE: 10,
    PLAYER_MAX_HEALTH: 100,
    
    // Game Mechanics
    COIN_VALUE: 10,
    BONUS_MULTIPLIER: 1.5,
    
    // Audio Settings
    MASTER_VOLUME: 1.0,
    MUSIC_VOLUME: 0.7,
    SFX_VOLUME: 0.8,
    
    // Graphics Settings
    GRAPHICS_QUALITY: {
        LOW: {
            SHADOWS: false,
            PARTICLES: false,
            POST_PROCESSING: false,
            TEXTURE_QUALITY: 'low'
        },
        MEDIUM: {
            SHADOWS: true,
            PARTICLES: true,
            POST_PROCESSING: false,
            TEXTURE_QUALITY: 'medium'
        },
        HIGH: {
            SHADOWS: true,
            PARTICLES: true,
            POST_PROCESSING: true,
            TEXTURE_QUALITY: 'high'
        }
    },
    
    // Game States
    STATES: {
        MENU: 'menu',
        PLAYING: 'playing',
        PAUSED: 'paused',
        GAME_OVER: 'gameOver',
        VICTORY: 'victory'
    },
    
    // Debug Settings
    DEBUG: {
        SHOW_FPS: true,
        SHOW_HITBOXES: false,
        SHOW_PHYSICS: false,
        GOD_MODE: false
    }
};
